import { render, staticRenderFns } from "./ScoringCriterion.vue?vue&type=template&id=c0053dd0&"
import script from "./ScoringCriterion.vue?vue&type=script&lang=js&"
export * from "./ScoringCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports